<template>
  <div>
    <p class="text-2xl mb-3">
      Please review the following information before proceeding.
    </p>
    <d-field label="Are you a liason for your organization?">
      <div>
        <d-radio v-model="checkedIsLiason" :native-value="true">
          Yes
        </d-radio>
        <d-radio v-model="checkedIsLiason" :native-value="false">
          No
        </d-radio>
      </div>
    </d-field>
    <div class="py-10">
      <div v-if="showConflictLiasonMessage">
        <p class="text-2xl font-bold mb-3">
          Important Note:
        </p>
        <p class="mb-3">
          QCP's records indicate that you are not the Designated QCP Liaison for your company. Please inform your company's
          management so that they may provide QCP with the correct name of the current Liaison, or appoint a Liaison (meeting
          the criteria outlined above) and provide us with that name. Liaison information should be forwarded using our website
          e-mail address: <a href="mailto:info@awiqcp.org">info@awiqcp.org</a>. In addition to the name and contact information for the Designated QCP Liaison, the
          e-mail must confirm that the Liaison has been appointed by a company owner or president.
        </p>
        <p class="mb-3">
          If you still wish to take the test for educational purposes only, you may do so now by pressing the "Continue" button below.
        </p>
      </div>
      <div v-if="showCorrectNotLiasonMessage">
        <p class="text-2xl font-bold mb-3">
          Important Note:
        </p>
        <p>
          Although you have indicated you are not the Designated QCP Liaison for your company, our records indicate that your
          company has appointed you as such. Among other responsibilities (such as signing project certification documents on
          behalf of your company), be aware that your company's fulfilment of QCP's written test requirements is contingent upon
          your personal written test scores. If you believe that our records are incorrect, or that you have been erroneously
          appointed by your company as its QCP Liaison, please inform your company's management so that they may provide QCP with
          the correct name of the Liaison, or appoint a Liaison (meeting the criteria outlined above). Liaison information or
          questions should be forwarded using our website e-mail address: <a href="mailto:info@awiqcp.org">info@awiqcp.org</a>. In addition to the name and contact
          information for the Designated QCP Liaison, the e-mail must confirm that the Liaison has been appointed by a company
          owner or president.
        </p>
      </div>
    </div>
    <div class="flex flex-wrap justify-end py-16">
      <d-tooltip v-if="checkedIsLiason === null" label="You must select an option before continuing">
        <d-button disabled>
          Continue
        </d-button>
      </d-tooltip>
      <d-button v-else @click="startTest">
        Continue
      </d-button>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  const { mapGetters, mapActions } = createNamespacedHelpers('tests');

  export default {
    data() {
      return {
        checkedIsLiason: null,
      };
    },

    computed: {
      ...mapGetters([
        'contactData',
      ]),

      computedContactIsLiason() {
        return this.contactData.contact_is_liaison === '1';
      },

      showConflictLiasonMessage() {
        return !this.computedContactIsLiason && this.checkedIsLiason;
      },

      showCorrectNotLiasonMessage() {
        return this.computedContactIsLiason && this.checkedIsLiason === false;
      },
    },

    async mounted() {
      if (this.$d2Auth.hasRole('Drafter')) {
        this.$router.replace({ name: 'question', params: { questionNum: 1 } });
      }
    },

    methods: {
      ...mapActions([
        'updateTestData',
        'updateQuestions',
      ]),

      startTest() {
        this.$router.push({ name: 'question', params: { questionNum: 1 } });
      },
    },
  };
</script>